/**
 * Tax permission keys (catalog `tax.*` and the tax reports `rpt.*`, docs/contracts/tax.md §5). The API checks the same
 * keys; preparing, reviewing and closing a VAT return are separate (G5, D7a).
 */
export const taxPermissions = {
  codeView: "tax.tax_code.view",
  codeCreate: "tax.tax_code.create",
  codeUpdate: "tax.tax_code.update",
  codeDelete: "tax.tax_code.delete",
  determinationView: "tax.determination.view",
  determinationUpdate: "tax.determination.update",
  settingsView: "tax.settings.view",
  settingsUpdate: "tax.settings.update",
  returnView: "tax.vat_return.view",
  returnCreate: "tax.vat_return.create",
  returnUpdate: "tax.vat_return.update",
  returnClose: "tax.vat_return.post",
  returnDelete: "tax.vat_return.delete",
  returnPrint: "tax.vat_return.print",
  eInvoiceView: "tax.einvoice.view",
  eInvoiceSubmit: "tax.einvoice.submit",
  eInvoiceDeviceUpdate: "tax.einvoice_device.update",
  withholdingCertificatePrint: "tax.withholding_certificate.print",
  taxLedgerView: "rpt.tax_ledger.view",
  reconciliationView: "rpt.tax_reconciliation.view",
  withholdingReportView: "rpt.withholding_tax.view",
} as const;

/** Plan module of Tax (always on: every plan with finance documents needs it). */
export const taxModule = "tax";
